import IndexerSearchResult from './IndexerSearchResult';

const searchResultMapper = {
  install(Vue) {
    Vue.prototype.$searchResultMapper = IndexerSearchResult;
  },
};

export default searchResultMapper;
